module.exports = __webpack_public_path__ + "static/media/commercial.4a46d40b.svg";